export { FavoriteStar } from '~/web-frontend-components/std/ui/FavoriteStar';



// WEBPACK FOOTER //
// ./src/web-frontend-components/std/UI.js